// Legal copy for Privacy Policy and Terms of Service screens.

export const LEGAL_DOCS = {
    privacy: {
        id: "privacy",
        title: "Privacy Policy",
        updated: "August 25, 2026",
        sections: [
            {
                heading: "Overview",
                paragraphs: [
                    "Memory Mix-Up is published by Courageous Corgis. This Privacy Policy explains what information we collect, how we use it, and the choices you have.",
                    "By playing Memory Mix-Up, you agree to this Privacy Policy. If you do not agree, please do not use the app.",
                ],
            },
            {
                heading: "Information we collect",
                paragraphs: [
                    "Account information: If you sign in, we may store your account ID, display name, Game ID (GID), and profile cosmetics you equip.",
                    "Gameplay data: Progress, collection unlocks, inventory, Treats balance, achievements, and leaderboard scores needed to run the game.",
                    "Purchase and entitlement data: Store purchases, restorations, and related receipt metadata processed through our payment partners (such as Apple, Google, or RevenueCat).",
                    "Device and diagnostics: Basic technical data such as app version, platform, and crash or performance signals that help us keep the game stable.",
                    "Ads (when enabled): If ads are shown, ad partners may collect device advertising identifiers and related data under their own policies. Removing ads (where offered) limits ad-related collection from those partners.",
                ],
            },
            {
                heading: "How we use information",
                paragraphs: [
                    "To provide and sync your game progress across devices when you are signed in.",
                    "To operate leaderboards, friends features, Store purchases, and customer support.",
                    "To improve reliability, prevent abuse, and understand how features perform.",
                    "We do not sell your personal information.",
                ],
            },
            {
                heading: "Sharing",
                paragraphs: [
                    "We share data with service providers that help us operate Memory Mix-Up, including cloud hosting, authentication, analytics/diagnostics, payments, and advertising partners when ads are used.",
                    "Public or semi-public features such as leaderboards and friend profiles may show your username, GID, cosmetics, and scores you opt into.",
                    "We may disclose information if required by law or to protect players, our rights, or safety.",
                ],
            },
            {
                heading: "Children",
                paragraphs: [
                    "Memory Mix-Up is intended for a general audience. We do not knowingly collect personal information from children under 13 (or the equivalent minimum age in your region) for the purpose of selling it or using it for targeted advertising.",
                    "If you believe a child has provided personal information inappropriately, contact us and we will take reasonable steps to delete it.",
                ],
            },
            {
                heading: "Data retention and security",
                paragraphs: [
                    "We retain account and gameplay data while your account is active and as needed to provide the service, comply with legal obligations, or resolve disputes.",
                    "We use reasonable administrative and technical safeguards, but no method of transmission or storage is 100% secure.",
                ],
            },
            {
                heading: "Your choices",
                paragraphs: [
                    "You can update profile display settings in the app where available.",
                    "You can request account or data deletion by contacting us. Some records may be retained when legally required.",
                    "Device settings may let you limit ad tracking or reset advertising identifiers.",
                ],
            },
            {
                heading: "Contact",
                paragraphs: [
                    "Questions about this Privacy Policy: privacy@courageouscorgis.com",
                    "Publisher: Courageous Corgis",
                ],
            },
        ],
    },
    terms: {
        id: "terms",
        title: "Terms of Service",
        updated: "August 25, 2026",
        sections: [
            {
                heading: "Agreement",
                paragraphs: [
                    "These Terms of Service govern your use of Memory Mix-Up, published by Courageous Corgis. By downloading, accessing, or playing the game, you agree to these Terms and our Privacy Policy.",
                    "If you do not agree, do not use the app.",
                ],
            },
            {
                heading: "The game",
                paragraphs: [
                    "Memory Mix-Up is a digital entertainment product. Features, content, balances, Store offers, and availability may change over time as we update the game.",
                    "Some features require an internet connection, a signed-in account, or platform Store access.",
                ],
            },
            {
                heading: "Accounts and conduct",
                paragraphs: [
                    "You are responsible for activity on your account and for choosing an appropriate display name.",
                    "Do not cheat, exploit bugs for unfair advantage, harass other players, attempt unauthorized access, or interfere with the service.",
                    "We may suspend or terminate access for violations of these Terms or to protect the game and players.",
                ],
            },
            {
                heading: "Virtual items and purchases",
                paragraphs: [
                    "Treats, packs, boosts, hearts, cosmetics, and similar items are virtual goods licensed for use in Memory Mix-Up. They have no real-world cash value outside the app and are generally non-transferable.",
                    "Real-money purchases are processed by the platform Store (such as Apple App Store or Google Play) under that Store’s terms. Taxes, billing, and refunds are handled according to those Store policies unless required otherwise by law.",
                    "Preview or beta pricing and entitlements may differ from final release offers.",
                ],
            },
            {
                heading: "Ads and optional removals",
                paragraphs: [
                    "The game may show advertisements unless you purchase or unlock an ads-removed entitlement where offered.",
                    "Ad availability and partners may change.",
                ],
            },
            {
                heading: "Intellectual property",
                paragraphs: [
                    "Memory Mix-Up, including art, characters, audio, text, code, and trademarks, is owned by Courageous Corgis or its licensors. You may not copy, modify, distribute, or reverse engineer the game except as allowed by law.",
                ],
            },
            {
                heading: "Disclaimer and limitation of liability",
                paragraphs: [
                    "THE GAME IS PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, TO THE FULLEST EXTENT PERMITTED BY LAW.",
                    "TO THE FULLEST EXTENT PERMITTED BY LAW, COURAGEOUS CORGIS IS NOT LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF DATA, PROGRESS, OR VIRTUAL ITEMS, ARISING FROM YOUR USE OF THE GAME.",
                    "Some regions do not allow certain disclaimers or limits; in those regions, our liability is limited to the maximum extent permitted by law.",
                ],
            },
            {
                heading: "Changes",
                paragraphs: [
                    "We may update these Terms from time to time. Continued use of Memory Mix-Up after changes become effective means you accept the updated Terms.",
                    "The “Updated” date at the top of this document shows the latest revision.",
                ],
            },
            {
                heading: "Contact",
                paragraphs: [
                    "Questions about these Terms: legal@courageouscorgis.com",
                    "Publisher: Courageous Corgis",
                ],
            },
        ],
    },
};

export function getLegalDoc(docId) {
    return LEGAL_DOCS[docId] || null;
}
